/**
 * @param value - The number to round
 * @param maxDecimalPlaces - Maximum number of decimal places (default: 2, clamped to 0-10)
 * @returns The rounded number
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get parseNumber () {
        return parseNumber;
    },
    get toFixed () {
        return toFixed;
    }
});
const toFixed = (value, maxDecimalPlaces = 2)=>{
    const decimalPlaces = Math.min(Math.max(maxDecimalPlaces, 0), 10);
    const multiplier = 10 ** decimalPlaces;
    const roundedValue = Math.round(value * multiplier) / multiplier;
    if (Number.isNaN(roundedValue)) {
        return 0;
    }
    return roundedValue;
};
const parseNumber = (value)=>{
    if (typeof value === "number") {
        return value;
    }
    if (!value && value !== 0 || !(typeof value === "string")) {
        return null;
    }
    const asInt = Number(value);
    if (asInt.toString() !== value) {
        return null;
    }
    return asInt;
};
